(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leila-brand-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(section) {
      var hero = section.querySelector('.leila-wayback-hero');
      if (!hero) return;

      var slides = Array.from(hero.querySelectorAll('[data-slide-index]'));
      var dots = Array.from(hero.querySelectorAll('[data-slide-to]'));
      var prev = hero.querySelector('[data-slide-action="prev"]');
      var next = hero.querySelector('[data-slide-action="next"]');
      if (!slides.length) return;

      var index = 0;
      var timer = null;
      var autoplaySeconds = Number(section.getAttribute('data-autoplay-seconds') || '5');
      if (!Number.isFinite(autoplaySeconds) || autoplaySeconds < 3) autoplaySeconds = 5;

      function paint() {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function go(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        paint();
      }

      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        timer = setInterval(function () {
          go(index + 1);
        }, autoplaySeconds * 1000);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var nextIndex = Number(dot.getAttribute('data-slide-to') || '0');
          go(nextIndex);
          start();
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          go(index - 1);
          start();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          go(index + 1);
          start();
        });
      }

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      paint();
      start();
    }

    document.querySelectorAll('[data-leila-wayback-home]').forEach(function (section) {
      initHero(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
